import React from 'react'
import AppLayout from '../../layout/components/AppLayout'
import { Link } from 'react-router-dom'
import { Block, Bloodtype, Campaign, CardMembership, ChatBubble, EditNote, Grading, Groups2, List, LocalPolice, Message, Newspaper, QuestionAnswer, SpeakerNotes, SupportAgent, Vaccines } from '@mui/icons-material'


function PortalDashboardComponent() {
  return (
    <AppLayout>
        <div className='container'>
            <div className='row mt-5 text-center'>
                
                <div className='col-md-6 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><Groups2 style={{fontSize:60}} /></h3>
                            <p>About Us</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-warning p-3 ' >
                        <Link to={"/complaint/list"} className='btn '   >
                            <h3><SupportAgent style={{fontSize:60}} /></h3>
                            <p>Emergency Helpline</p>
                        </Link>
                    </div>
                </div>

            </div>

            <div className='row mt-2'>
                <div className='col-md-12'>
                    <h3>Complaint</h3>
                </div>
            </div>

            <div className='row'>

                <div className='col-md-6 my-3'>
                    <div className='card bg-light p-3 ' >
                        <Link to={"/complaint/form/1"} className='btn'   >
                        <h3> <i style={{fontSize:60}} className="fa-solid fa-dumpster"></i> </h3>
                            <p>Garbage pick up Request</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card p-3 ' >
                        <Link to={"/complaint/form/14"} className='btn'   >
                            <h3> <i style={{fontSize:60}} className="fa-solid fa-timeline"></i> </h3>
                            <p>Sewerage Blocked</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-light p-3 ' >
                        <Link to={"/complaint/form/25"} className='btn'   >
                            <h3> <i style={{fontSize:60}} className="fa-solid fa-shield-dog"></i> </h3>
                            <p>Stray Dogs</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card p-3 ' >
                        <Link to={"/complaint/form/8"} className='btn'   >
                            <h3> <i style={{fontSize:60}} className="fa-solid fa-paw"></i> </h3>
                            <p>Dead Animal</p>
                        </Link>
                    </div>
                </div>
                
                <div className='col-md-6 my-3'>
                    <div className='card bg-dark p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><SpeakerNotes style={{fontSize:60}} /></h3>
                            <p>Book My Complaint</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-success p-3 ' >
                        <Link to={"/complaint/list"} className='btn text-white'   >
                            <h3><List style={{fontSize:60}} /></h3>
                            <p>My Complaint List</p>
                        </Link>
                    </div>
                </div>


            </div>

            <div className='row mt-2'>
                <div className='col-md-12'>
                    <h3>Other Information</h3>
                </div>
            </div>

            <div className='row'>

                <div className='col-md-6 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/complaint/list"} className='btn text-white'   >
                            <h3><QuestionAnswer style={{fontSize:60}} /></h3>
                            <p>FAQ</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><Newspaper style={{fontSize:60}} /></h3>
                            <p>News</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><EditNote style={{fontSize:60}} /></h3>
                            <p>Feedback</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><CardMembership style={{fontSize:60}} /></h3>
                            <p>Certificates</p>
                        </Link>
                    </div>
                </div>                
            </div>

            <div className='row mt-5'>
                <div className='col-md-12'>
                    <div  className="blockquote-footer">What's Near Me</div>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-3 my-3'>
                    <div className='card bg-success p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><Vaccines style={{fontSize:60}} /></h3>
                            <p>Hospitals</p>
                        </Link>
                    </div>
                </div>
                <div className='col-md-3 my-3'>
                    <div className='card bg-danger p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><Bloodtype style={{fontSize:60}} /></h3>
                            <p>Blood Bank</p>
                        </Link>
                    </div>               
                </div>
                <div className='col-md-3 my-3'>
                    <div className='card bg-warning p-3 ' >
                        <Link to={"/complaint/form"} className='btn'   >
                            <h3><LocalPolice style={{fontSize:60}} /></h3>
                            <p>Police Station</p>
                        </Link>
                    </div>               
                </div>

                <div className='col-md-3 my-3'>
                    <div className='card bg-dark p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><LocalPolice style={{fontSize:60}} /></h3>
                            <p>MC Office</p>
                        </Link>
                    </div>               
                </div>
            </div>
        </div>

        

        
    </AppLayout>
  )
}

export default PortalDashboardComponent